module.exports = __webpack_public_path__ + "img/icon3.e36c46a0.png";